import { NavItem } from "../types";

/**
 * Un ítem está activo si su ruta coincide con la actual o si alguno de sus
 * descendientes (hijo o nieto) coincide. Recorre el árbol recursivamente.
 */
export const isItemActive = (item: NavItem, currentPath: string): boolean => {
	if (item.path === currentPath) return true;
	return (
		item.children?.some((child) => isItemActive(child, currentPath)) ?? false
	);
};
